export const goToTeleconf = (appointmentId, userId = '') => {
  if (userId) {
    userId = `/user_id/${userId}`
  }
  window.location.href = `${process.env.VITTUDE_OFFLINE_URL}/consultorio_virtual/${appointmentId}${userId}`
}
